import { defineAction } from '~/prix'
import { z } from 'zod'
import residenceIdentificationPlateDeleteAction from './residenceIdentificationPlateDelete.action.json' with { type: 'json' }
import { residenceIdentificationPlateObject } from '../residenceIdentificationPlateObject'

const residenceIdentificationPlateDeleteDefinition = defineAction({
  ...residenceIdentificationPlateDeleteAction,

  input: z.object({
    id: residenceIdentificationPlateObject.shape.id,
  }),
  output: z.object({}),
})

export default residenceIdentificationPlateDeleteDefinition
